import React, {useState, useEffect} from 'react';
import {Paper, Typography, Slide, IconButton} from '@material-ui/core';
import {Close as CloseIcon} from '@material-ui/icons';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    offlineBar: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#f39c12',
        color: 'white',
        padding: '8px',
        textAlign: 'center',
        fontSize: '14px',
    },
    notificationContainer: {
        position: 'fixed',
        top: '72px', // Below app bar
        right: '16px',
        zIndex: 9998,
        maxWidth: 350,
    },
    warningNotification: {
        backgroundColor: '#ff9800',
        color: 'white',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    successNotification: {
        backgroundColor: '#4caf50',
        color: 'white',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    notificationText: {
        flex: 1,
        fontSize: '14px',
    },
    closeButton: {
        color: 'white',
        padding: '4px',
    }
}));

const OfflineIndicator = () => {
    const classes = useStyles();
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showOfflineNotification, setShowOfflineNotification] = useState(false);
    const [showOnlineNotification, setShowOnlineNotification] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowOnlineNotification(true);
            setShowOfflineNotification(false);

            // Auto hide online notification after 3 seconds
            setTimeout(() => {
                setShowOnlineNotification(false);
            }, 3000);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowOfflineNotification(true);
            setShowOnlineNotification(false);

            // Auto hide offline notification after 3 seconds
            setTimeout(() => {
                setShowOfflineNotification(false);
            }, 3000);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <>
            {/* Persistent offline indicator bar */}
            {!isOnline && (
                <div className={classes.offlineBar}>
                    You're offline - showing cached data
                </div>
            )}

            {/* Notification container */}
            <div className={classes.notificationContainer}>
                {/* Offline notification */}
                <Slide direction="left" in={showOfflineNotification} mountOnEnter unmountOnExit>
                    <Paper elevation={4} className={classes.warningNotification}>
                        <Typography className={classes.notificationText}>
                            You're now offline. Showing cached data.
                        </Typography>
                        <IconButton
                            className={classes.closeButton}
                            onClick={() => setShowOfflineNotification(false)}
                            size="small"
                        >
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </Paper>
                </Slide>

                {/* Online notification */}
                <Slide direction="left" in={showOnlineNotification} mountOnEnter unmountOnExit>
                    <Paper elevation={4} className={classes.successNotification}>
                        <Typography className={classes.notificationText}>
                            You're back online! Data will be refreshed.
                        </Typography>
                        <IconButton
                            className={classes.closeButton}
                            onClick={() => setShowOnlineNotification(false)}
                            size="small"
                        >
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </Paper>
                </Slide>
            </div>
        </>
    );
};

export default OfflineIndicator;